/* Supply › Reports › Stock Reports — hub of stock sub-reports. */
import React from "react";
import { ReportHub } from "./reportShared";
import { PHARMACY_ROUTES } from "../../../Route/path";

const CARDS = [
  {
    title: "Batchwise Stock Report",
    desc: "Detailed view of the current stock status of the inventory, by batch.",
    path: PHARMACY_ROUTES.STOCK_REPORT_BATCHWISE,
  },
  {
    title: "Expiry Report",
    desc: "Detailed view of all items which are expired or about to expire.",
    path: PHARMACY_ROUTES.STOCK_REPORT_EXPIRY,
  },
  {
    title: "Low Stock Report",
    desc: "Items running low on hand — candidates for reorder.",
    path: PHARMACY_ROUTES.STOCK_REPORT_LOW,
  },
  {
    title: "Out of Stuck Report",
    desc: "Orders stuck due to stock shortage — generate and download a CSV.",
    path: PHARMACY_ROUTES.STOCK_REPORT_OUT_OF_STUCK,
  },
  {
    title: "Inventory Snapshot",
    desc: "Opening stock, purchases, sales, returns and closing stock per batch for any period.",
    path: PHARMACY_ROUTES.STOCK_REPORT_SNAPSHOT,
  },
];

const StockReport = () => (
  <ReportHub title="Stock Reports" sub="Inventory, expiry, and stock-level reports" cards={CARDS} />
);

export default StockReport;
